<template>
  <a-upload :customRequest="handleRequest" :show-upload-list="false">
    <a-button>
      <upload-outlined></upload-outlined>
      上传文件
    </a-button>
  </a-upload>
</template>
<script setup lang="ts">
import { UploadOutlined } from "@ant-design/icons-vue";
import { FileService } from "@/api/services/FileService";
import { message } from "ant-design-vue";
import { UploadRequestOption } from "ant-design-vue/lib/vc-upload/interface";

defineProps<{
  modelValue: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const handleRequest = async (option: UploadRequestOption) => {
  const res = await FileService.Upload({ file: option.file as Blob });
  if (res.code === 0) {
    message.success("上传成功");
    emit("update:modelValue", res.data);
  } else {
    message.error(res.msg);
  }
};
</script>
